// extracted by mini-css-extract-plugin
export var headerContainer = "Header-module--headerContainer--1xq9J";
export var backContainer = "Header-module--backContainer--3ZMSI";
export var logoWrapper = "Header-module--logoWrapper--P2vmy";
export var logo = "Header-module--logo--OCmta";